module.exports = __webpack_public_path__ + "static/media/cdu_optyma.bfee7553.png";